/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agents_Issue_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to issue relay API key." |
*
* @param {Agents_Issue_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agents_issue_error = /** @type {((inputs?: Agents_Issue_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Issue_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("API-Schlüssel konnte nicht erstellt werden.")
	return /** @type {LocalizedString} */ ("Failed to issue relay API key.")
});